import React, { useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import BackdropContext from './BackdropContext';
import CoolLoading from '../../../wedding-wardrobe/src/components/base/CoolLoading';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const BackdropWrapper = ({ children }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);

  const classes = useStyles();

  return (
    <BackdropContext.Provider value={{ backdropOpen, setBackdropOpen }}>
      {children}
      <Backdrop className={classes.backdrop} open={backdropOpen}>
        <CoolLoading />
      </Backdrop>
    </BackdropContext.Provider>
  );
};

export default BackdropWrapper;
